import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { BonusActionFormInput } from './input-form.component';

export default [
    registerFormInputComponent('bonus-action-form-input', BonusActionFormInput),
];
